import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import LoadingPage from './components/LoadingPage';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import 'primereact/resources/primereact.min.css'; //core css
import 'primeicons/primeicons.css'; //icons
import 'bootstrap-icons/font/bootstrap-icons.css';
//import 'primeflex/primeflex.css';

import 'primereact/resources/themes/lara-light-indigo/theme.css'; //theme
import './styles/App.css';

import reportWebVitals from './utils/reportWebVitals';

import './utils/i18n';
import routes from './AppRoutes';
import { BASENAME, USE_ADMIN, API_BASEURL, AUTHORIZATION } from './Constants';
import axios from 'axios';

if (API_BASEURL) {
    axios.defaults.baseURL = API_BASEURL;
}
if (AUTHORIZATION) {
    axios.defaults.headers.common['Authorization'] = AUTHORIZATION;
}

// Load conditionally to exclude from build (only works if the env variable is set)
if (USE_ADMIN) {
    const adminInitApp = require('./admin/init').default;
    adminInitApp(routes);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const router = createBrowserRouter(routes, { basename: BASENAME });

root.render(
    <Suspense fallback={<LoadingPage />}>
        <RouterProvider router={router} fallbackElement={<LoadingPage />} />
    </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
